app.controller('modalMarketingCodeCtrl', function ($scope, $uibModalInstance, urlServices, toaster, params) {
    $scope.userid = params.userid;
    $scope.search = '';
    $scope.marketingCodes = [];
    $scope.selectedCodes = {};

    function normalizeTextValue(value) {
        return String(value || '').trim();
    }

    function normalizeMarketingCode(marketingCode) {
        return normalizeTextValue(marketingCode).toUpperCase();
    }

    function normalizePrefix(prefix) {
        return normalizeTextValue(prefix).toUpperCase().replace(/\s+/g, '').slice(0, 5);
    }

    function buildOptionItem(item) {
        return angular.extend({}, item, {
            MarketingCode: normalizeTextValue(item.MarketingCode || item.marketing_code).toUpperCase(),
            TotalCustomer: Number(item.TotalCustomer || item.total_customer || item.totalCustomer || 0),
            DefaultPrefix: normalizePrefix(item.DefaultPrefix || item.defaultPrefix || item.awb_prefix || item.AwbPrefix)
        });
    }

    $scope.getVisibleMarketingCodes = function () {
        var searchText = String($scope.search || '').toUpperCase();

        return ($scope.marketingCodes || []).filter(function (item) {
            var haystack = [item.MarketingCode, item.TotalCustomer, item.DefaultPrefix].join(' ').toUpperCase();

            if (!searchText) {
                return true;
            }
            return haystack.indexOf(searchText) >= 0;
        });
    };

    $scope.isSelected = function (marketingCode) {
        return !!$scope.selectedCodes[normalizeMarketingCode(marketingCode)];
    };

    $scope.getSelectedCount = function () {
        var total = 0;

        angular.forEach($scope.selectedCodes, function (selected) {
            if (selected) {
                total += 1;
            }
        });

        return total;
    };

    $scope.onMarketingCodeChange = function (item) {
        var marketingCode = normalizeMarketingCode(item.MarketingCode);

        if (!marketingCode) {
            return;
        }

        if ($scope.selectedCodes[marketingCode]) {
            $scope.selectedCodes[marketingCode] = true;
        } else {
            delete $scope.selectedCodes[marketingCode];
        }
    };

    $scope.toggleMarketingCode = function (item) {
        var marketingCode = normalizeMarketingCode(item.MarketingCode);

        if (!marketingCode) {
            return;
        }

        $scope.selectedCodes[marketingCode] = !$scope.selectedCodes[marketingCode];
        $scope.onMarketingCodeChange(item);
    };

    $scope.pilihSemua = function () {
        angular.forEach($scope.getVisibleMarketingCodes(), function (item) {
            var marketingCode = normalizeMarketingCode(item.MarketingCode);

            if (marketingCode) {
                $scope.selectedCodes[marketingCode] = true;
                $scope.onMarketingCodeChange(item);
            }
        });
    };

    $scope.batalPilih = function () {
        angular.forEach($scope.getVisibleMarketingCodes(), function (item) {
            var marketingCode = normalizeMarketingCode(item.MarketingCode);

            if (marketingCode) {
                delete $scope.selectedCodes[marketingCode];
                $scope.onMarketingCodeChange(item);
            }
        });
    };

    $scope.simpanMarketingCodes = function () {
        var items = [];

        angular.forEach($scope.selectedCodes, function (selected, marketingCode) {
            if (selected) {
                items.push({
                    marketing_code: marketingCode
                });
            }
        });

        urlServices.simpanData('api/user/' + $scope.userid + '/marketing-codes', { items: items }, function (g, s) {
            if (g) {
                toaster.pop('error', 'Error', g.err || 'Gagal menyimpan marketing code');
            } else {
                toaster.pop('success', 'Marketing Code', 'Marketing code disimpan');
                $uibModalInstance.close(true);
            }
        });
    };

    urlServices.ambilData('api/user-marketing-code-options', {}, function (e, d) {
        if (e) {
            toaster.pop('error', 'Error', e.err || 'Error mengambil marketing code');
            return;
        }

        $scope.marketingCodes = (d || []).map(function (item) {
            return buildOptionItem(item);
        }).filter(function (item) {
            return !!item.MarketingCode;
        });
        urlServices.ambilData('api/user/' + $scope.userid + '/marketing-codes', {}, function (e2, d2) {
            if (e2) {
                toaster.pop('error', 'Error', e2.err || 'Error mengambil marketing code user');
                return;
            }

            angular.forEach(d2 || [], function (item) {
                var marketingCode = normalizeMarketingCode(item.marketing_code || item.MarketingCode);
                var optionExists = false;

                if (marketingCode) {
                    $scope.selectedCodes[marketingCode] = true;
                    angular.forEach($scope.marketingCodes, function (option) {
                        if (option.MarketingCode === marketingCode) {
                            optionExists = true;
                        }
                    });
                    if (!optionExists) {
                        $scope.marketingCodes.push(buildOptionItem(item));
                    }
                }
            });
        });
    });
});